<template>
  <div class="pages" :style="{ minHeight: height + 'px' }">
    <navTop></navTop>
    <div class="box">
      <div class="box-li" @click="goProgress">
        <p>View Work Progress</p>
        <img src="../../assets/left.png" />
      </div>
      <div class="box-li" @click="goReport" v-if="type != 4">
        <p>View Work Report</p>
        <img src="../../assets/left.png" />
      </div>
      <div class="box-li" @click="goPicture">
        <p>View Certificate Picture</p>
        <img src="../../assets/left.png" />
      </div>
      <div class="box-li" @click="goNewProgress">
        <p>View Work Photo Video</p>
        <img src="../../assets/left.png" />
      </div>
    </div>
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import navFooter from '../../components/navFooter.vue';

export default {
  name: 'schedule',
  components: {
    navTop,
    navFooter
  },
  data() {
    return {
      height: '',
      id: '',
      type: ''
    };
  },
  created() {
    if (!sessionStorage.getItem('uid')) {
      this.$router.push({path: '/'});
    } else {
      this.id = this.$route.query.id;
      this.type = this.$route.query.type;
      this.height = window.innerHeight;
    }
  },
  methods: {
    goProgress() {
      if (this.type == 0) {
        // this.$router.push({ path: '/workProgress', query: { id: this.id } });
        this.$router.push({path: '/list', query: {id: this.id}});
      } else if (this.type == 1) {
        this.$router.push({path: '/ly', query: {id: this.id}});
      } else if (this.type == 2) {
        this.$router.push({path: '/jy', query: {id: this.id}});
      } else if (this.type == 3) {
        this.$router.push({path: '/sc', query: {id: this.id}});
      } else if (this.type == 4) {
        this.$router.push({path: '/bx', query: {id: this.id}});
      }
    },
    goNewProgress() {
      if (this.type == 0) {
        // this.$router.push({ path: '/workProgress', query: { id: this.id } });
        this.$router.push({path: '/list', query: {id: this.id}});
      } else if (this.type == 1) {
        this.$router.push({path: '/newLy', query: {id: this.id}});
      } else if (this.type == 2) {
        this.$router.push({path: '/newJy', query: {id: this.id}});
      } else if (this.type == 3) {
        this.$router.push({path: '/sc', query: {id: this.id}});
      } else if (this.type == 4) {
        this.$router.push({path: '/bx', query: {id: this.id}});
      }
    },
    goReport() {
      if (this.type == 0) {
        // this.$router.push({ path: '/workProgress', query: { id: this.id } });
        this.$router.push({path: '/list', query: {id: this.id, name: 'xiazai'}});
      } else {
        window.open('http://39.105.212.82/userfiles/null/fj/reportImg/' + this.id + '.pdf');
      }
      // window.open('http://39.105.212.82/userfiles/null/fj/reportImg');

      // if (this.type == 0) {
      // 	this.$router.push({ path: '/workReport', query: { id: this.id } });
      // }
    },
    goPicture() {
      this.$router.push({path: '/certificatePicture', query: {id: this.id}});
    }
  }
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;
  min-height: 10vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box {
    max-width: 800px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;
    padding-top: 40px;
    padding-bottom: 80px;
    box-sizing: border-box;

    .box-li {
      width: 100%;
      height: 90px;
      border: 1px solid $blue-primary-rgba;
      border-radius: 45px;
      background: rgba(15, 43, 63, 0.8);
      backdrop-filter: blur(10px);
      box-shadow: 0 0 25px $blue-glow;
      margin-bottom: 25px;
      padding: 0 40px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 5px 35px $blue-primary;
        border-color: $blue-primary;
        background: rgba(15, 43, 63, 0.9);
      }

      p {
        font-size: 24px;
        color: $blue-primary;
        line-height: 1.2em;
        font-weight: 500;
        text-shadow: $text-glow;
      }

      img {
        width: 20px;
        height: 35px;
        display: block;
        filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        transition: all 0.3s ease;
      }

      &:hover img {
        transform: translateX(5px);
        filter: brightness(1.5) drop-shadow(0 0 8px $blue-primary);
      }
    }

    .box-li:last-child {
      margin: 0;
    }
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;
  position: relative;
  z-index: 2;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 768px) {
  .pages {
    .box {
      .box-li {
        height: 75px;
        padding: 0 30px;

        p {
          font-size: 18px;
        }

        img {
          width: 16px;
          height: 28px;
        }
      }
    }
  }
}
</style>